module.exports = "//static.hsappstatic.net/ui-addon-avatars/static-2.7155/images/default-avatar.png"